import { createNamedContext } from '@utils';
import { PersistentURLStateContextValue } from './interfaces';

export const PersistentURLStateContext = createNamedContext<PersistentURLStateContextValue | undefined>(undefined, 'PersistentURLState.Context');